<template>
  <div style="">
    <div class="login-page">
      <top></top>
      <div class="container">
        <div class="container cons">
          <div class="col-lg-12"
               style="overflow: auto">
            <div class="contact-info">
              <h3>联系我们</h3>
              <div class="strip-line"></div>
            </div>
            <div style="display: flex">
              <div class="left">
                <p style="
                    padding-left: 15px;
                    padding-right: 15px;
                    font-size: 15px;
                    line-height: 20px;
                  ">
                  珠海瑞启智慧科技有限公司于2023年成立于珠海，是一家以高新科技研发和人工智能应用开发为主的初创型企业。主要技术方向为大数据及人工智能技术的研发及商业化应用，应用领域为信息技术及数据领域的自动判断及辅助决策。瑞启在政府及社会各界的关怀及支持下，瑞启科技已与众多知名企业及机构达成战略合作，由瑞启主导推出了“WoYou工资”平台，专为企业及个人提供互联网增值服务。未来瑞启将持续聚力于AI+在行业领域内的深度应用，为中国制造到中国创造贡献自己的一份力量。
                </p>
              </div>
              <div class="right">
                <div style="
                    width: 50%;
                    margin-top: 10px;
                    padding-left: 0;
                    padding-right: 0;
                  ">
                  <div class="col-lg-12">
                    <h5>Phone</h5>
                    <span>客服：13600360639</span>
                    <div style="margin-top: 5px">销售：19292036042</div>
                  </div>
                  <div class="col-lg-12">
                    <h5>Address</h5>
                    <span>广东省珠海市香洲区紫荆路社保大厦1204</span>
                  </div>
                  <div class="col-lg-12">
                    <h5>Email</h5>
                    <span><a href="#"
                         style="color: #000000">i.lion@qq.com</a></span>
                  </div>
                </div>
                <div style="width: 50%">
                  <img src="@/assets/img/weixinkefu.png" />
                  <div class="clearfix"></div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-12 contact_form">
            <div class="contact-info">
              <h3>意见或建议</h3>
              <div class="strip-line"></div>
            </div>
            <el-form lass="form-horizontal"
                     :model="form"
                     :rules="rules"
                     ref="form">
              <div class="contact-left">
                <!-- <input
                  type="text"
                  name="NickName"
                  placeholder="您的姓名"
                  required=""
                /> -->
                <el-form-item prop="name">
                  <el-input v-model="form.name"
                            placeholder="你的姓名"></el-input>
                </el-form-item>
                <el-form-item prop="email">
                  <el-input v-model="form.email"
                            placeholder="您的邮箱"></el-input>
                </el-form-item>
                <el-form-item prop="subject">
                  <el-input v-model="form.subject"
                            placeholder="主题"></el-input>
                </el-form-item>
                <!-- <input
                  type="text"
                  name="Email"
                  placeholder="您的邮箱"
                  required=""
                /> -->
                <!-- <input
                  type="text"
                  name="Subject"
                  placeholder="主题"
                  required=""
                /> -->
              </div>
              <div class="contact-right">
                <textarea placeholder="请留下您宝贵的意见或建议（字数请控制在200字以内）..."
                          required=""
                          v-model="form.infoContent"></textarea>
              </div>
              <div class="clearfix"></div>
              <span class="submit-btn"><el-button size="medium"
                           type="primary"
                           @click="onSubmit('form')">提交</el-button></span>
            </el-form>
          </div>
          <imageAuthen :visible="imageVisible"
                       @close="imageVisible = false"
                       @enter="enter"></imageAuthen>
          <div class="clearfix"></div>
        </div>
      </div>
    </div>
    <Foot />
  </div>
</template>

<script>
import Foot from "./_foot";
import top from "./_top_menu";
import imageAuthen from "@/components/imageAuthen";
export default {
  components: {
    Foot,
    top,
    imageAuthen,
  },
  data () {
    let validateEmail = (rule, value, callback) => {
      //使用正则表达式进行验证手机号码
      if (!/^\w+@[a-z0-9]+\.[a-z]+$/.test(value)) {
        callback(new Error("邮箱格式不正确"));
      } else {
        callback();
      }
    };
    return {
      imageVisible: false,
      form: {},
      rules: {
        name: [{ required: true, message: "请输入你的姓名", trigger: "blur" }],
        email: [
          { required: true, message: "请输入你的邮箱", trigger: "blur" },
          { validator: validateEmail, trigger: "blur" },
        ],
        subject: [
          { required: true, message: "请输入你的主题", trigger: "blur" },
        ],
      },
    };
  },
  created () { },

  directives: {
    focus: {
      // 指令的定义
      inserted: function (el) {
        el.focus();
      },
    },
  },

  methods: {
    goBack () {
      this.$router.push("/login");
    },
    enter (v) {
      let sendData = {
        subject: this.form.subject,
        name: this.form.name,
        email: this.form.email,
        uuid: v.uuid,
        vierificationCode: v.captcha,
        infoContent: this.form.infoContent,
      };
      this.$api.manage.SuggestEdit(sendData).then((res) => {
        if (res.code === 0) {
          this.form = {};
          this.$message.success("提交成功");
        }
      });
    },
    onSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.imageVisible = true;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
      console.log(this.form);
    },
  },
};
</script>

<style lang="less" scoped>
.login-page {
  width: 100%;
  background-color: #fff;
  // height: 100vh;
  .loginBtn {
    cursor: pointer;
  }
  .container {
    width: 1170px;
    margin: 0 auto;
    padding-top: 60px;
    height: 99vh;
    .left {
      width: 50%;
      padding: 0 15px;
    }
    .right {
      width: 50%;
      display: flex;
      padding: 0 15px;
      img {
        width: 192px;
        height: 192px;
      }
      h5 {
        font-weight: 700;
        font-size: 14px;
        margin-top: 10px;
        margin-bottom: 10px;
      }
    }
    .contact-info {
      text-align: center;
      margin-bottom: 3em;
      h3 {
        text-align: center;
        margin: 0 0 20px 0;
        font-size: 28px;
        font-family: "Roboto Slab", serif;
        color: #5bc0de;
        font-weight: normal;
        text-transform: uppercase;
      }
      .strip-line {
        background: #000;
        height: 2px;
        width: 17%;
        margin: 0 auto;
      }
    }
    .contact_form {
      button {
        color: #fff;
        background-color: #5bc0de;
        border-color: #46b8da;
      }
      .contact-left {
        width: 30%;
        float: left;
        input[type="text"] {
          width: 100%;
          color: #000;
          margin: 0 23px 28px 0;
          font-size: 14px;
          padding: 12px 10px;
          outline: none;
          border: 1px solid #cccccc;
        }
      }

      .contact-right {
        width: 68%;
        float: right;
        textarea {
          width: 100%;
          color: #000;
          font-size: 14px;
          resize: none;
          height: 185px;
          padding: 12px;
          outline: none;
          border: 1px solid #cccccc;
        }
      }
    }
  }
}
.copy-right {
  position: fixed;
  bottom: 0;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  text-align: center;
  padding: 10px 0;
}
</style>
